import { render, staticRenderFns } from "./selectGroup.vue?vue&type=template&id=0897e45a&scoped=true"
import script from "./selectGroup.vue?vue&type=script&lang=js"
export * from "./selectGroup.vue?vue&type=script&lang=js"
import style0 from "./selectGroup.vue?vue&type=style&index=0&id=0897e45a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0897e45a",
  null
  
)

export default component.exports